<template>
  <your-skin-section-template id="your-skin" v-bind="patientSkinData" :scores="scores" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import YourSkinSectionTemplate from '@/components/your-skin/YourSkinSectionTemplate.vue';

import { types } from '@/store/types';
import { ALL_DYSFUNCTION_NAME } from '@/constants/dysfunctions';

export default {
  name: 'YourSkinSection',
  components: {
    YourSkinSectionTemplate
  },
  data() {
    return {
      shouldStartContentAnimation: false,
      activeDysfunctionName: ALL_DYSFUNCTION_NAME,
      isDiscoverModalShown: false
    };
  },
  computed: {
    ...mapState({
      patientSkinData: types.state.PATIENT_SKIN_DATA
    }),
    ...mapGetters({
      scores: types.getters.SCORES
    })
  }
};
</script>
